import {Injectable, isDevMode} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {CountryConfigEvent} from '../../../ui/shared/event-listeners/country-config-event/country-config-event';

@Injectable({
  providedIn: 'root',
})
export class SagGuard implements CanActivate {

  constructor(private router: Router, private contryConfigEvent: CountryConfigEvent) {}

  canActivate(){
    return this.contryConfigEvent.getCountryConfig.pipe(map((res: any)=>{
      if(isDevMode || res.general?.sag ) return true;
      this.router.navigate(['']);
      return false;
    }));
  }
}
